"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var type_undefined_1 = require("./type-undefined");
// Resolves a path deep in an object
// e.g. path: Path such as: "module_a.foo"
// e.g. object data like: { "module_a": { "foo": "Foo!"} }
// returns "Foo!"
exports.resolvePathInObject = function (path, object) {
    var splits = path.split(".");
    var value;
    var walk = function (subTree, i) {
        if (!subTree)
            return;
        value = subTree[splits[i]];
        if (typeof value !== type_undefined_1.TYPE_UNDEFINED && i == splits.length - 1) {
            return value;
        }
        else {
            return walk(value, ++i);
        }
    };
    return walk(object, 0);
};
//# sourceMappingURL=resolve-path-in-object.js.map